// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/SupportThread.css - UPDATED FOR LIGHT THEME */

.ticket-thread-container {
  margin-top: 1.5rem;
  max-height: 60vh; /* Increased max height */
  overflow-y: auto;
  padding: 1rem;
  background: var(--bg-secondary); /* Very light gray background */
  border-radius: var(--border-radius-lg); /* Consistent rounding */
  border: 1px solid var(--border-primary); /* Light border */
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.thread-message {
  padding: 0.8rem 1.2rem;
  border-radius: 18px; /* Keep bubble shape */
  max-width: 85%; /* Slightly wider max width */
  width: fit-content;
  word-wrap: break-word;
  border: 1px solid var(--border-primary); /* Add light border to all messages */
  box-shadow: var(--shadow-lg); /* Add subtle shadow */
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-secondary); /* Medium gray text */
}

.message-header strong {
  font-weight: 600;
  color: var(--text-primary); /* Dark text for names */
}

.message-body p {
  white-space: pre-wrap;
  line-height: 1.6;
  font-size: 0.95rem;
  margin: 0;
  color: var(--text-primary); /* Dark text for message body */
}

/* User's original message & replies (left-aligned) */
.user-message {
  background-color: var(--bg-primary); /* White background */
  align-self: flex-start;
  border-bottom-left-radius: 4px; /* Keep pointed corner */
  border-color: var(--border-primary);
}
.user-message .message-header strong {
  color: var(--text-accent); /* Red text for user name */
}
.user-message .message-body {
  color: var(--text-secondary); /* Medium gray for user message body */
}

/* Replies from ANY admin (right-aligned, different color) */
/* Simplified: No 'other'/'self', just admin style */
.admin-message {
  background-color: var(--bg-accent-light); /* Light red tint background */
  border-color: var(--border-accent); /* Light red border */
  align-self: flex-end;
  border-bottom-right-radius: 4px; /* Pointed corner on the right */
}
.admin-message .message-header strong {
  color: var(--primary-red-dark); /* Darker red for admin name */
}
.admin-message .message-body {
  color: var(--text-primary); /* Dark text for admin message body */
}


/* Reply form styles */
.reply-form {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-primary); /* Light border */
}

.reply-form textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid var(--border-primary); /* Light border */
  border-radius: var(--border-radius-lg); /* Consistent rounding */
  background: var(--bg-primary); /* White background */
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}
.reply-form textarea:focus {
  outline: none;
  border-color: var(--text-accent); /* Red border on focus */
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15); /* Red ring */
}
.reply-form textarea::placeholder {
    color: #9CA3AF; /* gray-400 equivalent */
}

/* Use primary button style */
.reply-form .action-button {
  display: block;
  margin-left: auto;
  /* Assuming .action-button inherits primary styles (red gradient) */
  /* If not, copy primary button styles here */
  background-image: var(--gradient-button);
  background-color: var(--primary-red-medium);
  color: white;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
}
.reply-form .action-button:hover:not(:disabled) {
  box-shadow: var(--shadow-button-hover);
  transform: scale(1.03);
}
.reply-form .action-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  background-image: none;
  background-color: var(--border-primary);
  color: var(--text-secondary);
}

.ticket-closed-notice {
  margin-top: 1.5rem;
  padding: 1rem 1.5rem;
  text-align: center;
  background: var(--error-bg-light); /* Light red background */
  color: var(--error-color); /* Red text */
  border: 1px solid var(--error-color); /* Red border */
  border-radius: var(--border-radius-lg); /* Consistent rounding */
  font-weight: 500;
  font-size: 0.95rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/SupportThread.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,kBAAkB;EAClB,gBAAgB,EAAE,yBAAyB;EAC3C,gBAAgB;EAChB,aAAa;EACb,+BAA+B,EAAE,+BAA+B;EAChE,sCAAsC,EAAE,wBAAwB;EAChE,uCAAuC,EAAE,iBAAiB;EAC1D,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB,EAAE,sBAAsB;EAC3C,cAAc,EAAE,6BAA6B;EAC7C,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC,EAAE,qCAAqC;EAC9E,4BAA4B,EAAE,sBAAsB;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,4BAA4B,EAAE,qBAAqB;AACrD;;AAEA;EACE,gBAAgB;EAChB,0BAA0B,EAAE,wBAAwB;AACtD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,0BAA0B,EAAE,+BAA+B;AAC7D;;AAEA,qDAAqD;AACrD;EACE,mCAAmC,EAAE,qBAAqB;EAC1D,sBAAsB;EACtB,8BAA8B,EAAE,wBAAwB;EACxD,mCAAmC;AACrC;AACA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;AACA;EACE,4BAA4B,EAAE,sCAAsC;AACtE;;AAEA,4DAA4D;AAC5D,oDAAoD;AACpD;EACE,wCAAwC,EAAE,8BAA8B;EACxE,kCAAkC,EAAE,qBAAqB;EACzD,oBAAoB;EACpB,+BAA+B,EAAE,gCAAgC;AACnE;AACA;EACE,8BAA8B,EAAE,8BAA8B;AAChE;AACA;EACE,0BAA0B,EAAE,qCAAqC;AACnE;;;AAGA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C,EAAE,iBAAiB;AAChE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uCAAuC,EAAE,iBAAiB;EAC1D,sCAAsC,EAAE,wBAAwB;EAChE,6BAA6B,EAAE,qBAAqB;EACpD,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gCAAgC,EAAE,wBAAwB;EAC1D,6CAA6C,EAAE,aAAa;AAC9D;AACA;IACI,cAAc,EAAE,wBAAwB;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,iBAAiB;EACjB,mEAAmE;EACnE,4CAA4C;EAC5C,wCAAwC;EACxC,2CAA2C;EAC3C,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC,EAAE,yBAAyB;EAC5D,yBAAyB,EAAE,aAAa;EACxC,oCAAoC,EAAE,eAAe;EACrD,sCAAsC,EAAE,wBAAwB;EAChE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* src/styles/SupportThread.css - UPDATED FOR LIGHT THEME */\n\n.ticket-thread-container {\n  margin-top: 1.5rem;\n  max-height: 60vh; /* Increased max height */\n  overflow-y: auto;\n  padding: 1rem;\n  background: var(--bg-secondary); /* Very light gray background */\n  border-radius: var(--border-radius-lg); /* Consistent rounding */\n  border: 1px solid var(--border-primary); /* Light border */\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.thread-message {\n  padding: 0.8rem 1.2rem;\n  border-radius: 18px; /* Keep bubble shape */\n  max-width: 85%; /* Slightly wider max width */\n  width: fit-content;\n  word-wrap: break-word;\n  border: 1px solid var(--border-primary); /* Add light border to all messages */\n  box-shadow: var(--shadow-lg); /* Add subtle shadow */\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-size: 0.8rem;\n  color: var(--text-secondary); /* Medium gray text */\n}\n\n.message-header strong {\n  font-weight: 600;\n  color: var(--text-primary); /* Dark text for names */\n}\n\n.message-body p {\n  white-space: pre-wrap;\n  line-height: 1.6;\n  font-size: 0.95rem;\n  margin: 0;\n  color: var(--text-primary); /* Dark text for message body */\n}\n\n/* User's original message & replies (left-aligned) */\n.user-message {\n  background-color: var(--bg-primary); /* White background */\n  align-self: flex-start;\n  border-bottom-left-radius: 4px; /* Keep pointed corner */\n  border-color: var(--border-primary);\n}\n.user-message .message-header strong {\n  color: var(--text-accent); /* Red text for user name */\n}\n.user-message .message-body {\n  color: var(--text-secondary); /* Medium gray for user message body */\n}\n\n/* Replies from ANY admin (right-aligned, different color) */\n/* Simplified: No 'other'/'self', just admin style */\n.admin-message {\n  background-color: var(--bg-accent-light); /* Light red tint background */\n  border-color: var(--border-accent); /* Light red border */\n  align-self: flex-end;\n  border-bottom-right-radius: 4px; /* Pointed corner on the right */\n}\n.admin-message .message-header strong {\n  color: var(--primary-red-dark); /* Darker red for admin name */\n}\n.admin-message .message-body {\n  color: var(--text-primary); /* Dark text for admin message body */\n}\n\n\n/* Reply form styles */\n.reply-form {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-primary); /* Light border */\n}\n\n.reply-form textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid var(--border-primary); /* Light border */\n  border-radius: var(--border-radius-lg); /* Consistent rounding */\n  background: var(--bg-primary); /* White background */\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 100px;\n  margin-bottom: 1rem;\n  transition: all 0.3s ease;\n}\n.reply-form textarea:focus {\n  outline: none;\n  border-color: var(--text-accent); /* Red border on focus */\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15); /* Red ring */\n}\n.reply-form textarea::placeholder {\n    color: #9CA3AF; /* gray-400 equivalent */\n}\n\n/* Use primary button style */\n.reply-form .action-button {\n  display: block;\n  margin-left: auto;\n  /* Assuming .action-button inherits primary styles (red gradient) */\n  /* If not, copy primary button styles here */\n  background-image: var(--gradient-button);\n  background-color: var(--primary-red-medium);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: var(--border-radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n}\n.reply-form .action-button:hover:not(:disabled) {\n  box-shadow: var(--shadow-button-hover);\n  transform: scale(1.03);\n}\n.reply-form .action-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n  background-image: none;\n  background-color: var(--border-primary);\n  color: var(--text-secondary);\n}\n\n.ticket-closed-notice {\n  margin-top: 1.5rem;\n  padding: 1rem 1.5rem;\n  text-align: center;\n  background: var(--error-bg-light); /* Light red background */\n  color: var(--error-color); /* Red text */\n  border: 1px solid var(--error-color); /* Red border */\n  border-radius: var(--border-radius-lg); /* Consistent rounding */\n  font-weight: 500;\n  font-size: 0.95rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
